import { liverigResource } from 'plugin-alerts-dashboard-channels/channelAlerts/services/liverig/helpers'
import {
    AxisSource,
    NormalizedAssetInfo,
    WidgetAssetChannel,
    WidgetAssetInfo,
    WidgetConfig
} from 'plugin-alerts-dashboard-channels/channelAlerts/types'

export const getAssetInfo = async (
    axis: AxisSource,
    channelInfo: WidgetAssetChannel,
    widgetRequest: LiveWidgetRequest<unknown>
): Promise<WidgetAssetInfo> => {
    const asset =
        getLookupAssetsInfo(axis, widgetRequest) ??
        (await liverigResource.get<NormalizedAssetInfo>(`assets/${axis.assetId}/normalizer`))

    const assetInfo: WidgetAssetInfo = {
        event_type: asset.event_type,
        name: asset.name,
        channel: {
            identifier: channelInfo.qualifier,
            name: channelInfo.name,
            unit: channelInfo.unit
        }
    }

    return assetInfo
}

export const getChannelInfo = (widgetConfig: WidgetConfig, axis: AxisSource): [WidgetAssetChannel, number] => {
    let channelIndex = 0

    const channel = widgetConfig.assets.reduce((acc, curr, idx) => {
        // TODO: What about calculated channels? Can we have both?
        const channels = curr.channels?.length ? curr.channels : curr.calculatedChannels ?? []
        const val = channels.find(({ qualifier }) => qualifier === axis.qualifier)
        if (val) {
            channelIndex = idx

            return val
        }

        return acc
    }, {} as WidgetAssetChannel)

    return [channel, channelIndex]
}

export const getLookupAssetsInfo = (axis: AxisSource, request: LiveWidgetRequest<unknown>): NormalizedAssetInfo => {
    const lookupType = axis.assetId.includes('lookup') ? axis.assetId.split('/')[1] : null
    if (!lookupType) return

    const lookupValues = request.lookupValues[lookupType]
    if (!lookupValues) throw new Error(`Lookup values for "${lookupType}" not found`)

    const value = lookupValues[0] // TODO - How to manage multiple assets?
    if (!value) return

    // Cannot define from which asset type the name is coming from
    // const asset = await liverigResource.get<AssetInfo[]>(`assets/list?name=${value}`)
    return {
        name: value,
        event_type: null
    }
}
